import Alpine from "alpinejs";

const rebuyMegaMenuExtensions = {
  cartItemCount: 0,
  checkRebuyStatus() {
    if (typeof Rebuy !== "undefined" && Rebuy?.SmartCart?.status === "ready") {
      return true;
    }
    return false;
  },
  openCartDrawer() {
    if (this.checkRebuyStatus()) {
      Rebuy.SmartCart.show();
      this.closeMenus();
    }
  },
  closeCartDrawer() {
    if (this.checkRebuyStatus()) {
      Rebuy.SmartCart.hide();
    }
  },
};

const customCartMegaMenuExtensions = {
  openCartDrawer() {
    document.documentElement.classList.add("overflow-hidden");
    this.isCartDrawerOpen = true;
    this.isSearchOpen = false;
    this.isMenuOpen = false;
  },
  closeCartDrawer() {
    document.documentElement.classList.remove("overflow-hidden");
    this.isCartDrawerOpen = false;
  },
};

export const alpineStoreMegaMenu = () =>
  Alpine.store("megaMenu", {
    isMenuOpen: false,
    isSearchOpen: false,
    isCartDrawerOpen: false,
    headerTextColor: "dark",
    isScrolled: false,
    cartType: CART_TYPE || "custom",
    init() {
      this.onScroll();
      document.addEventListener("scroll", () => {
        this.onScroll();
      });

      if (location.hash) {
        addEventListener("DOMContentLoaded", () => {
          const el = document.getElementById(location.hash.replace("#", ""));
          if (el) {
            setTimeout(() => {
              window.scrollTo({
                top: el.offsetTop,
                left: 0,
                behavior: "instant",
              });
            }, 200);
          }
        });
      }

      if (this.cartType === "rebuy") {
        Object.assign(this, rebuyMegaMenuExtensions);
        document.addEventListener("rebuy:cart.change", (event) => {
          this.cartItemCount = event.detail.cart.itemCount();
        });
      }

      if (this.cartType === "custom") {
        Object.assign(this, customCartMegaMenuExtensions);
      }
    },
    handleOpenMenu() {
      this.isMenuOpen = true;
      document.documentElement.classList.add("overflow-hidden");
    },
    handleCloseMenu() {
      this.isMenuOpen = false;
      document.documentElement.classList.remove("overflow-hidden");
    },
    handleSearchClick() {
      if (this.isMenuOpen) {
        this.isMenuOpen = false;
        document.documentElement.classList.remove("overflow-hidden");
        setTimeout(() => {
          this.isSearchOpen = true;
        }, 300);
        return;
      }
      this.isSearchOpen = !this.isSearchOpen;
    },
    handleKeydownEscape() {
      this.isMenuOpen = false;
      this.isSearchOpen = false;
      document.documentElement.classList.remove("overflow-hidden");
    },
    handleUnderlayClick() {
      this.isMenuOpen = false;
      this.isSearchOpen = false;
      document.documentElement.classList.remove("overflow-hidden");
    },
    handleCampaignClick() {
      this.isMenuOpen = false;
      this.isSearchOpen = false;
      document.documentElement.classList.remove("overflow-hidden");
      const sections = document.querySelectorAll("section");
      console.log(sections);
      sections[1].style.scrollMarginTop = "var(--nav-height)";
      sections[1].scrollIntoView({ behavior: "smooth" });
    },
    closeMenus() {
      this.isMenuOpen = false;
      this.isSearchOpen = false;
      document.documentElement.classList.remove("overflow-hidden");
    },
    onScroll() {
      if (window.scrollY > 100) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }
    },
  });
